import rand from "@/utils/rand";
import {AwsService} from "@/simulation/AwsService";
import wait from "@/utils/wait";

export class ExternalApi implements AwsService {
    id = rand();
    name = 'API (Twitter…)';
    averageDuration = 300;
    errorRate = 0;
    successes = 0;
    errors = 0;

    invoke(): void {
        this.call();
    }

    call(): Promise<void> {
        const duration = rand(this.averageDuration / 2, this.averageDuration * 2);

        return wait(duration)
            .then(() => {
                const rand = Math.floor(Math.random() * 100);
                if (this.errorRate <= rand) {
                    this.successes++;
                } else {
                    this.errors++;
                    throw 'The HTTP call failed';
                }
            });
    }

    reset() {
        this.successes = 0;
        this.errors = 0;
    }

    outputs(): Array<AwsService> {
        return [];
    }
}
